import Swiper from 'swiper'
import { Navigation } from 'swiper/modules'

import 'swiper/scss'
import 'swiper/css/navigation'

export function initSiteFormatsSwiper() {
  const el = document.querySelector('[data-site-formats-swiper]')
  if (!el) {
    return
  }

  const n = el.querySelectorAll('.swiper-slide').length
  if (n < 1) {
    return
  }

  // Форматы сайтов: мобилка 1.2 (виден следующий), ПК 3
  new Swiper(el, {
    modules: [Navigation],
    watchOverflow: true,
    speed: 600,
    spaceBetween: 16,
    slidesPerView: 1.2,
    grabCursor: true,
    navigation: {
      prevEl: el.querySelector('.site-formats__nav--prev'),
      nextEl: el.querySelector('.site-formats__nav--next'),
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 18,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
    },
  })
}

